import { render, staticRenderFns } from "./PurchasedReceipt.vue?vue&type=template&id=288dc7ff&scoped=true"
import script from "./PurchasedReceipt.vue?vue&type=script&lang=js"
export * from "./PurchasedReceipt.vue?vue&type=script&lang=js"
import style0 from "./PurchasedReceipt.vue?vue&type=style&index=0&id=288dc7ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288dc7ff",
  null
  
)

export default component.exports